import React from 'react'
import { useParams } from 'react-router-dom'
import { PacketPresentBody } from './editor/PacketPresentBody'
import { usePacketFonts } from './usePacketFonts'

export function PresentSprintPacket() {
  usePacketFonts()
  const { businessID, packetID } = useParams<{ businessID: string; packetID: string }>()
  return <PacketPresentBody businessID={Number(businessID)} packetID={Number(packetID)} />
}
